import { API } from '../api';
import axiosInstance from '../axiosConfig';

export const addLocationApi = async (body) => {
  const response = await axiosInstance.post(API.LOCATION.ADD_LOCATION, body);
  return response;
};

export const updateLocationApi = async (body) => {
  const response = await axiosInstance.patch(API.LOCATION.UPDATE_LOCATION, body);
  return response;
};

export const findLocationById = async (id) => {
  const response = await axiosInstance.get(API.LOCATION.FIND_BY_ID + id);
  return response;
};

export const deleteLocationById = async (id) => {
  const response = await axiosInstance.delete(API.LOCATION.DELETE + id);
  return response;
};

export const checkLocationEligibility = async (id) => {
  const response = await axiosInstance.get(API.LOCATION.LOCATION_ELIGILIBILITY + id);
  return response;
};
